import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'dai-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  imports: [FormsModule]
})
export class FeedbackDialogComponent {
  @Input() to!: string;
  @Input() subject!: string;
  @Input() body!: string;

  constructor(public activeModal: NgbActiveModal) {}

  submit() {
    const mailtoLink = `mailto:${this.to}?subject=${encodeURIComponent(this.subject)}&body=${encodeURIComponent(this.body)}`;
    window.location.href = mailtoLink;
    this.activeModal.close('submitted');
  }
}
